<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.account_list_alert")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-sync" :text="$t('ui.refresh')" isModal=false type="button" @click="submit")
            b-row
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                .alert.alert-warning.mb-1
                  span {{ $t("ui.total_member") }}:
                  span.badge.badge-warning.ml-1 {{ totalRows }}
                  br
                  span {{ $t("message.player_alert_tooltips") }}
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.tblAgent.table-sm.table-hover.table-bordered(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="memberListAlert" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged" :tbody-tr-class="rowClass")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(account_id)="row")
                    .d-flex
                      span #[b {{ row.item.account_id.toUpperCase() }}]
                      .ml-auto(v-if="$helpers.getVisible(editAccount)")
                        a.fas.fa-lg.fa-fw.fa-edit.text-primary(
                          v-b-modal.updateProfile
                          @click="setEditSelectedModal(row.item)"
                          :title="$t('ui.edit')"
                          style="cursor: pointer;"
                        )
                  template(v-slot:cell(credit_limit)="row")
                    span(:class="$helpers.getNumberClass(row.item.credit_limit)") #[b {{ row.item.credit_limit | currency }} ]
                  template(v-slot:cell(available_credit)="row")
                    span(:class="$helpers.getNumberClass(row.item.available_credit)") #[b {{ row.item.available_credit | currency }} ]

      updateProfile(:accountId="updateAccountID" :accountType="updateAccountType" @clicked="submit")

</template>

<script>
import config from "@/config"
import SubmitButton from "@/library/SubmitButton"
import updateProfile from "@/components/modal/updateProfile.vue"
import currency from "@/components/settings/currency.vue"
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    updateProfile,
    currency,
    DebounceInput
  },
  data() {
    return {
      memberListAlert: [],
      updateAccountID: "",
      updateAccountType: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      filter: null,
      sortBy: "account_id",
      sortDesc: false,
      currentPage: 1,
      totalRows: 0
    }
  },
  validations: {},
  computed: {
    editAccount() {
      return [config.accessRoles.editAccount]
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "20%"
          }
        },
        {
          key: "full_name",
          label: this.$t("ui.full_name"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "27%"
          }
        },
        {
          key: "credit_limit",
          label: this.$t("ui.credit_limit"),
          class: "align-middle text-right",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "available_credit",
          label: this.$t("ui.available_credit"),
          class: "align-middle text-right",
          thClass: "bg-grey",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "last_login_ip",
          label: this.$t("ui.login_ip"),
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "last_login_time",
          label: this.$t("ui.date_time"),
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "15%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function(){
    this.submit()
  },
  methods: {
    rowClass(item, type) {
      if (!item) return
      if (item.status === 'SUSPEND') return 'table-warning'
      if (item.status === 'CLOSE') return 'table-danger'
      if (item.status === 'FREEZE') return 'table-primary'
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable()
    },
    refreshTable() {
      this.$root.$emit("bv::table::refresh", "tblList")
    },
    submit: function() {
      this.getMemberListAlert()
    },
    setEditSelectedModal: function(account) {
      this.updateAccountID = account.account_id
      this.updateAccountType = account.account_type
    },
    getMemberListAlert: function() {
      if (!this.$v.$invalid) {
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("user/getMemberListAlert", { page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.loading = false
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
            if (this.submission.success == true) {
              this.memberListAlert = response.data
              this.totalRows = response.data.length > 0 ? this.memberListAlert[0]["totalrows"] : 0;
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag);
          });
      }
    }
  }
}
</script>